import { useState } from "#app"
import { useRouter } from "vue-router"

interface ProductNavigationData {
    productId: string
    page: number
    categoryPath: string
    scrollCompleted: boolean
}

export const useProductNavigation = () => {
    const navigationData = useState<ProductNavigationData | null>('product-navigation', () => null)

    const storeProductNavigation = (productId: string, page: number, categoryPath: string) => {
        navigationData.value = {
            productId,
            page,
            categoryPath,
            scrollCompleted: false
        }
    }

    const getNavigationData = () => {
        return navigationData.value
    }

    const markScrollCompleted = () => {
        if (navigationData.value) {
            navigationData.value.scrollCompleted = true
        }
    }

    const clearNavigationData = () => {
        navigationData.value = null
    }

    const interceptBrowserBack = () => {
        if (!import.meta.client) return

        const router = useRouter()
        
        // Listen for popstate (browser back/forward)
        const handlePopState = (event: PopStateEvent) => {
            const navData = navigationData.value
            
            if (navData && !navData.scrollCompleted) {
                // Prevent the default back navigation
                event.preventDefault()
                
                // Navigate to the correct page instead
                const targetUrl = `${navData.categoryPath}?${new URLSearchParams({
                    ...Object.fromEntries(new URLSearchParams(window.location.search)),
                    p: navData.page.toString()
                }).toString()}`
                
                // Replace current history entry with the correct page
                router.replace(targetUrl)
            }
        }

        // Add the listener
        window.addEventListener('popstate', handlePopState)
        
        // Return cleanup function
        return () => {
            window.removeEventListener('popstate', handlePopState)
        }
    }

    return {
        storeProductNavigation,
        getNavigationData,
        markScrollCompleted,
        clearNavigationData,
        interceptBrowserBack
    }
}